module.exports = __webpack_public_path__ + "static/media/ribbon-specialoffer-fr@2x.451ca05a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ribbon-specialoffer-fr@2x.png
// module id = 308
// module chunks = 0